module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA3XAAAN1wFCKJt4AAAAB3RJTUUH4QsHDAsrvZmywAAAANVJREFUSMft1jFKxEAUBuDPGLZyLVwLsckFxMILaJWLZG6g6GlyAb1C2LXWtRA8QcC1EAux2m202AxsY5ekmh8ezDDwPpjqZ5scd3jBGr89zRrLbnduB3vsEflvFshz3OCyKAp1XTv5/tRnPg6PVVWlbdsrXO9133jRNE3vWMxqOlOWJSwznGEwDE5/vuLxPMPEeJlkRk4CE5jABCYwgQncgpsRvU2Gt9iuhspqOovH1wz3EELYfegt7wdHQgjx+hCL8GKEIjzH/m77vsXzAFX/qdudwx/OKoHInNtgNgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/territorio_codigospostales.png
// module id = OM3W
// module chunks = 0